export default "__VITE_ASSET__BdM15hLP__"